import React, { useState, useEffect } from "react";
import { IPictureModel, IModelError, Nullable } from "../../Common/types";
import { IProfileDetailsModel, IPersonalInfo} from "../Details/types";
import fetcherGET from "../../Common/Fetch";
import Fetcher from "../../Common/Fetch";
import Signature from "../Details/Signature";

function Cert() {
    const [details, setDetails] = useState<IProfileDetailsModel>();
    const [profileDetails, setProfileDetails] = useState<IPersonalInfo>();

    useEffect(() => {
        Fetcher("/ProfileApi/GetDetails", {})
            .then(res => res.json())
            .then(
                (result) => {
                    setDetails(result.UpdatedItem);
                    setProfileDetails(result.UpdatedItem.profileDetails);
                    console.log(result.UpdatedItem);
                },
                (error) => {
                    console.log(error);
                }
            );
    }, [])

    return (
        <>
            {details &&
                <React.Fragment>
                    <Signature certName={details.accountDetails.CertName} certDate={details.accountDetails.CertExpDate} isLoginForm={false} />
                </React.Fragment>
            }
        </>
    )
}

export default Cert;